import { type DocumentNode, gql } from '@apollo/client';

/**
 * HiRes payload input type (defined in GraphQL schema)
 * The actual structure depends on the backend HiResPayload input type
 */
export interface HiResPayloadInput {
  [key: string]: unknown;
}

/**
 * Variables for sendHires mutation
 */
export interface SendHiresVariables {
  actionId?: string;
  payload: HiResPayloadInput;
}

/**
 * Send hires response payload structure
 */
export interface SendHiresPayload {
  response: string;
}

/**
 * Response structure for sendHires mutation
 */
export interface SendHiresResponse {
  sendHires: SendHiresPayload;
}

const sendHires: DocumentNode = gql`
  mutation SendHires($actionId: ID, $payload: HiResPayload!) {
    sendHires(actionId: $actionId, payload: $payload) {
      response
    }
  }
`;

export default sendHires;
